import type { Dict } from './en'

/**
 * TIẾNG VIỆT.
 *
 * Kiểu `Dict` (lấy từ en.ts) bắt buộc file này có ĐỦ khoá — thiếu một khoá là
 * `npm run typecheck` báo lỗi ngay, không đợi đến lúc người dùng nhìn thấy chữ
 * tiếng Anh lọt giữa trang tiếng Việt.
 *
 * Thêm ngôn ngữ mới: chép `en.ts` thành `<mã>.ts`, dịch, rồi thêm một dòng vào
 * `registry` trong `src/i18n/index.tsx`.
 */
export const vi: Dict = {
  nav: {
    home: 'Trang chủ',
    collection: 'Bộ sưu tập',
    maison: 'Về nhà chế tác',
    contact: 'Liên hệ',
    studio: 'Quản trị',
    signIn: 'Đăng nhập',
    signOut: 'Đăng xuất',
    menu: 'Menu',
    close: 'Đóng',
    openMenu: 'Mở menu',
  },

  common: {
    viewAll: 'Xem tất cả',
    loading: 'Đang tải…',
    save: 'Lưu',
    saving: 'Đang lưu…',
    cancel: 'Huỷ',
    delete: 'Xoá',
    edit: 'Sửa',
    back: 'Quay lại',
    search: 'Tìm kiếm',
    required: 'Bắt buộc',
    optional: 'Không bắt buộc',
    all: 'Tất cả',
    from: 'Từ',
    reset: 'Đặt lại',
    apply: 'Áp dụng',
    filters: 'Bộ lọc',
    copied: 'Đã sao chép',
    of: 'trên',
  },

  theme: {
    label: 'Giao diện',
    light: 'Sáng',
    dark: 'Tối',
    system: 'Theo hệ thống',
  },

  lang: {
    label: 'Ngôn ngữ',
  },

  movement: {
    label: 'Bộ máy',
    automatic: 'Tự động',
    manual: 'Lên dây cót tay',
    quartz: 'Pin thạch anh',
  },

  condition: {
    label: 'Tình trạng',
    new: 'Mới',
    pre_owned: 'Đã qua sử dụng',
    vintage: 'Cổ điển',
  },

  status: {
    published: 'Đang hiển thị',
    draft: 'Bản nháp',
    reserved: 'Đã giữ chỗ',
    sold: 'Đã bán',
  },

  home: {
    heroEyebrow: 'Từ 1948 · Genève',
    heroTitle: 'Giữ thời gian, một cách đẹp đẽ.',
    heroLead:
      'Một danh sách ngắn có chủ đích gồm những chiếc đồng hồ cơ — từng chiếc được thợ của nhà mở máy, canh chỉnh và bảo chứng.',
    heroCta: 'Khám phá bộ sưu tập',
    heroSecondary: 'Câu chuyện của nhà',
    searchTitle: 'Tìm chiếc đồng hồ của bạn',
    searchLead: '{count} hiện vật đang có tại cửa hiệu — chiếc nào cũng được thợ của nhà mở máy, canh giờ và bảo chứng.',
    quickAll: 'Tất cả',
    gridTitle: 'Đang có tại cửa hiệu',
    gridRefine: 'Lọc chi tiết',
    marqueeService: 'Bảo dưỡng trọn đời',
    marqueeAuthenticity: 'Chứng thực chính hãng',
    marqueeShipping: 'Giao hàng bảo hiểm toàn cầu',
    marqueeReturns: 'Đổi trả trong 14 ngày',
    collectionsEyebrow: 'Bộ sưu tập',
    collectionsTitle: 'Bốn dòng, một chuẩn mực',
    collectionsSubtitle:
      'Lặn biển, thanh lịch, bấm giờ và cổ điển. Mọi chiếc đều đo bằng một thước: bộ máy xứng đáng được giữ năm mươi năm.',
    featuredEyebrow: 'Tuyển chọn',
    featuredTitle: 'Mùa này tại cửa hiệu',
    featuredSubtitle: 'Do thợ cả của nhà tự tay chọn, có thể xem trực tiếp tại Hà Nội hoặc Genève.',
    storyEyebrow: 'Xưởng chế tác',
    storyTitle: 'Bảy mươi sáu năm bên một bàn thợ',
    storyBody:
      'Chúng tôi là thợ đồng hồ trước khi là người bán. Mỗi chiếc về đến cửa hiệu đều được mở máy, canh giờ ở sáu tư thế và chỉnh tay trước khi lên kệ — và ra về cùng cuốn sổ bảo dưỡng có chữ ký của chính người đã làm.',
    storyCta: 'Bước vào xưởng',
    serviceEyebrow: 'Cam kết',
    serviceTitle: 'Những gì đi cùng chiếc đồng hồ',
    service1Title: 'Chứng thực chính hãng',
    service1Body: 'Mỗi mã tham chiếu được đối chiếu với hồ sơ lưu của hãng và kèm giấy chứng nhận.',
    service2Title: 'Bảo dưỡng trọn đời',
    service2Body: 'Miễn phí canh chỉnh ba năm đầu, và một bàn thợ vẫn hiểu chiếc đồng hồ của bạn vào năm 2050.',
    service3Title: 'Giao hàng bảo hiểm',
    service3Body: 'Chuyển phát bảo hiểm toàn phần ra thế giới, giao tận tay trong nội thành Hà Nội và TP. Hồ Chí Minh.',
    visitEyebrow: 'Ghé thăm',
    visitTitle: 'Hãy ngồi xuống cùng chiếc đồng hồ trước khi quyết định',
    visitBody: 'Buổi xem riêng theo hẹn tại cả hai cửa hiệu. Có trà, có kính lúp, và không hề có sự thúc ép.',
    visitCta: 'Đặt lịch xem',
  },

  search: {
    label: 'Tìm kiếm',
    placeholder: 'Tìm theo tên, mã tham chiếu hoặc thương hiệu…',
    openHint: 'Tìm trong bộ sưu tập',
    recent: 'Đã tìm gần đây',
    clearRecent: 'Xoá',
    seeAll: 'Xem tất cả {count} kết quả',
    noResults: 'Không có gì khớp với “{q}”',
    noResultsBody: 'Thử ít chữ hơn, hoặc nhập mã tham chiếu như TA-300.24.',
    browseAll: 'Xem toàn bộ bộ sưu tập',
    resultsFor: 'Kết quả cho “{q}”',
  },

  catalog: {
    eyebrow: 'Bộ sưu tập',
    title: 'Toàn bộ hiện vật tại cửa hiệu',
    subtitle: 'Lọc theo dòng, bộ máy hoặc ngân sách. Giá hiển thị là giá cuối, đã gồm thuế và bảo dưỡng.',
    searchPlaceholder: 'Tìm theo tên hoặc mã tham chiếu…',
    collection: 'Dòng',
    maison: 'Thương hiệu',
    price: 'Giá',
    sort: 'Sắp xếp',
    sortRelevance: 'Khớp nhất',
    sortNewest: 'Mới về',
    sortPriceAsc: 'Giá từ thấp đến cao',
    sortPriceDesc: 'Giá từ cao xuống thấp',
    sortFeatured: 'Nổi bật trước',
    priceAny: 'Mọi mức giá',
    priceUnder5k: 'Dưới 5.000',
    price5to10k: '5.000 – 10.000',
    price10to20k: '10.000 – 20.000',
    priceOver20k: 'Trên 20.000',
    count: '{count} hiện vật',
    countOne: '1 hiện vật',
    emptyTitle: 'Không có chiếc nào khớp bộ lọc',
    emptyBody: 'Hãy nới khoảng giá hoặc bỏ bớt một bộ lọc — tuần nào cũng có hàng mới về.',
    clearFilters: 'Xoá bộ lọc',
  },

  watch: {
    reference: 'Mã tham chiếu',
    caseMaterial: 'Vỏ máy',
    caseSize: 'Đường kính',
    water: 'Chống nước',
    strap: 'Dây đeo',
    year: 'Năm sản xuất',
    specs: 'Thông số',
    description: 'Về chiếc đồng hồ này',
    enquire: 'Hỏi về chiếc này',
    availability: 'Tình trạng hàng',
    inStock: 'Có tại cửa hiệu',
    lastOne: 'Chỉ còn một chiếc',
    outOfStock: 'Đang được giữ chỗ',
    related: 'Có thể bạn cũng thích',
    backToCollection: 'Về bộ sưu tập',
    saved: 'Đã lưu',
    share: 'Chia sẻ',
    linkCopied: 'Đã sao chép liên kết',
    notFoundTitle: 'Chiếc này không còn được đăng',
    notFoundBody: 'Có lẽ nó đã tìm được chủ nhân. Phần còn lại của bộ sưu tập vẫn đang đợi bạn.',
  },

  enquiry: {
    title: 'Hỏi về chiếc đồng hồ này',
    subtitle: 'Để lại cách liên hệ, chúng tôi trả lời ngay trong ngày.',
    name: 'Tên của bạn',
    email: 'Email',
    phone: 'Số điện thoại',
    message: 'Nội dung',
    messagePlaceholder: 'Cuối tuần này tôi muốn xem chiếc này tại Hà Nội…',
    submit: 'Gửi câu hỏi',
    success: 'Cảm ơn bạn — chúng tôi sẽ liên hệ ngay trong ngày.',
    errorName: 'Xin cho biết tên của bạn',
    errorEmail: 'Địa chỉ email chưa hợp lệ',
    errorMessage: 'Hãy viết vài dòng nội dung',
  },

  maison: {
    eyebrow: 'Nhà chế tác',
    title: 'Một cửa hiệu dựng quanh chiếc bàn thợ',
    lead:
      'TEMPORA khởi đầu năm 1948 như một xưởng sửa chữa ở tầng trệt một chung cư tại Genève. Ba thế hệ sau, chúng tôi vẫn làm đúng việc ấy: mở vỏ, hiểu bộ máy, rồi mới quyết định chiếc đồng hồ có xứng đáng được bán hay không.',
    chapter1Title: 'Chúng tôi mua bộ máy, không mua cái tên',
    chapter1Body:
      'Mặt số có thể sơn lại, hộp có thể in mới. Bộ máy thì không biết nói dối. Mỗi chiếc đều được tháo rời, soi kính lúp và canh giờ ở sáu tư thế suốt 72 giờ trước khi được định giá.',
    chapter2Title: 'Một danh sách ngắn, giữ đúng sự thật',
    chapter2Body:
      'Thà đưa bạn xem mười hai chiếc chúng tôi dám bảo chứng còn hơn bốn trăm chiếc thì không. Chiếc nào không có ở đây là chiếc đó chưa đạt — và chúng tôi sẵn lòng nói rõ vì sao.',
    chapter3Title: 'Chiếc đồng hồ sống lâu hơn cuộc mua bán',
    chapter3Body:
      'Bảo dưỡng miễn phí ba năm và còn tiếp tục chừng nào nhà còn tồn tại. Hai mươi năm sau mang đồng hồ quay lại, vẫn bàn thợ ấy, vẫn bộ đồ nghề ấy đón nó.',
    statYears: 'Năm bên bàn thợ',
    statPieces: 'Hiện vật đã phục chế',
    statCountries: 'Quốc gia đã phục vụ',
    statService: 'Cam kết bảo dưỡng',
    ctaTitle: 'Hãy đến và nhìn qua kính lúp',
    ctaBody: 'Cả hai cửa hiệu đều có một phòng yên tĩnh dành cho buổi xem. Không buổi hẹn nào bị hối thúc.',
    ctaButton: 'Đặt buổi xem',
  },

  contact: {
    eyebrow: 'Liên hệ',
    title: 'Viết thư, gọi điện, hoặc đơn giản là ghé qua',
    subtitle: 'Mọi tin nhắn đều được trả lời trong ngày làm việc.',
    salons: 'Cửa hiệu',
    hours: 'Giờ mở cửa',
    hoursWeekday: 'Thứ Ba – Thứ Bảy, 10:00 – 19:00',
    hoursSunday: 'Chủ nhật & Thứ Hai, theo hẹn trước',
    phone: 'Điện thoại',
    email: 'Email',
    formTitle: 'Gửi tin nhắn',
    formSubject: 'Chủ đề',
    subjectViewing: 'Đặt buổi xem',
    subjectPiece: 'Một chiếc trong bộ sưu tập',
    subjectService: 'Bảo dưỡng đồng hồ của tôi',
    subjectOther: 'Việc khác',
  },

  auth: {
    signInTitle: 'Tài khoản cửa hiệu',
    signInSubtitle: 'Khu quản trị chỉ dành cho chủ cửa hiệu.',
    signUpTitle: 'Tạo tài khoản',
    signUpSubtitle: 'Lưu lại những chiếc bạn thích và theo dõi tình trạng của chúng.',
    name: 'Họ tên',
    email: 'Email',
    password: 'Mật khẩu',
    passwordHint: 'Tối thiểu 6 ký tự',
    signIn: 'Đăng nhập',
    signUp: 'Tạo tài khoản',
    toSignUp: 'Chưa có tài khoản? Tạo mới',
    toSignIn: 'Đã có tài khoản? Đăng nhập',
    ownerHintTitle: 'Tài khoản dùng thử',
    ownerHintBody:
      'Chưa cấu hình cơ sở dữ liệu nên phần đăng nhập đang chạy mô phỏng. Dùng {email} với mật khẩu bất kỳ từ 6 ký tự để vào khu quản trị của chủ cửa hiệu.',
    signedIn: 'Đã đăng nhập',
    signedOut: 'Đã đăng xuất',
    errorEmail: 'Hãy nhập địa chỉ email hợp lệ',
    errorPassword: 'Mật khẩu phải có ít nhất 6 ký tự',
  },

  guard: {
    title: 'Chỉ chủ cửa hiệu mới vào được',
    body: 'Khu quản trị — đăng tin và quản lý tin đăng — thuộc về tài khoản chủ cửa hiệu.',
    button: 'Đăng nhập bằng tài khoản chủ cửa hiệu',
    wrongAccountTitle: 'Tài khoản này không mở được khu quản trị',
    wrongAccountBody: 'Bạn đang đăng nhập bằng {email}. Hãy đăng xuất và dùng tài khoản chủ cửa hiệu.',
  },

  studio: {
    eyebrow: 'Khu quản trị',
    overview: 'Tổng quan',
    listings: 'Quản lý tin',
    newListing: 'Đăng tin',
    enquiries: 'Hộp thư',
    welcome: 'Chào {name}',
    welcomeBody: 'Mọi thứ cửa hiệu đưa ra công chúng đều được quản lý từ đây.',
    statPublished: 'Đang hiển thị',
    statDraft: 'Bản nháp',
    statReserved: 'Giữ chỗ & đã bán',
    statValue: 'Giá trị tồn kho',
    statEnquiries: 'Câu hỏi mới',
    recentEnquiries: 'Câu hỏi gần đây',
    recentListings: 'Tin đăng gần đây',
    viewPublic: 'Xem tại cửa hiệu',
    manageTitle: 'Quản lý tin đăng',
    manageSubtitle: 'Hiển thị, ẩn, định giá và gỡ từng chiếc trong cửa hiệu.',
    searchListings: 'Tìm trong tin đăng của bạn…',
    filterStatus: 'Trạng thái',
    tableWatch: 'Hiện vật',
    tablePrice: 'Giá',
    tableStatus: 'Trạng thái',
    tableViews: 'Lượt xem',
    tableDate: 'Ngày đăng',
    tableActions: 'Thao tác',
    emptyTitle: 'Chưa có tin đăng nào',
    emptyBody: 'Đăng chiếc đầu tiên và nó xuất hiện ngay tại cửa hiệu.',
    deleteTitle: 'Xoá tin đăng này?',
    deleteBody: '“{title}” sẽ bị gỡ khỏi cửa hiệu. Thao tác này không thể hoàn tác.',
    deleted: 'Đã xoá tin đăng',
    statusChanged: 'Đã cập nhật trạng thái',
    formNewTitle: 'Đăng một hiện vật',
    formEditTitle: 'Sửa tin đăng',
    formSubtitle: 'Tiếng Anh là bản gốc; các ô tiếng Việt không bắt buộc, bỏ trống thì tự lùi về tiếng Anh.',
    fieldTitle: 'Tên hiện vật',
    fieldTitleVi: 'Tên tiếng Việt',
    fieldReference: 'Mã tham chiếu',
    fieldCollection: 'Dòng',
    fieldMaison: 'Thương hiệu',
    fieldPrice: 'Giá bán',
    fieldOldPrice: 'Giá cũ',
    fieldOldPriceHint: 'Để 0 nếu không muốn hiện giá gạch ngang',
    fieldMovement: 'Bộ máy',
    fieldCase: 'Chất liệu vỏ',
    fieldSize: 'Đường kính',
    fieldWater: 'Chống nước',
    fieldStrap: 'Dây đeo',
    fieldYear: 'Năm sản xuất',
    fieldCondition: 'Tình trạng',
    fieldStock: 'Số lượng còn',
    fieldStatus: 'Trạng thái',
    fieldFeatured: 'Hiện trên trang chủ',
    fieldImage: 'URL ảnh chính',
    fieldGallery: 'URL ảnh bộ sưu tập',
    fieldGalleryHint: 'Mỗi dòng một URL',
    fieldDescription: 'Mô tả',
    fieldDescriptionVi: 'Mô tả tiếng Việt',
    sectionIdentity: 'Nhận diện',
    sectionSpecs: 'Thông số',
    addSpec: 'Thêm một dòng',
    sectionMedia: 'Hình ảnh',
    sectionCopy: 'Nội dung',
    sectionPublishing: 'Xuất bản',
    saveDraft: 'Lưu nháp',
    publish: 'Đăng lên cửa hiệu',
    updated: 'Đã cập nhật tin đăng',
    created: 'Đã đăng tin',
    errorTitle: 'Hiện vật cần có tên',
    errorPrice: 'Hãy nhập giá lớn hơn 0',
    errorImage: 'Bắt buộc có ảnh chính',
    inboxTitle: 'Hộp thư',
    inboxSubtitle: 'Tất cả khách đã hỏi về một chiếc đồng hồ, mới nhất lên đầu.',
    inboxEmpty: 'Chưa có câu hỏi nào',
    inboxEmptyBody: 'Tin nhắn gửi từ trang chi tiết đồng hồ sẽ về đây.',
    markAnswered: 'Đánh dấu đã trả lời',
    markArchived: 'Lưu trữ',
    enquiryNew: 'Mới',
    enquiryAnswered: 'Đã trả lời',
    enquiryArchived: 'Đã lưu trữ',
    aboutPiece: 'Hỏi về',
  },

  notFound: {
    title: 'Trang này đã lặng đi',
    body: 'Có thể liên kết đã cũ, hoặc hiện vật đã tìm được chủ nhân.',
    button: 'Về cửa hiệu',
  },

  footer: {
    tagline: 'Đồng hồ cơ tinh tuyển, do chính thợ của nhà chọn và bảo dưỡng.',
    explore: 'Khám phá',
    house: 'Về nhà chế tác',
    legal: 'Điều khoản & bảo mật',
    newsletterTitle: 'Bốn lá thư mỗi năm, lặng lẽ',
    newsletterBody: 'Hàng mới về và những ghi chép từ bàn thợ. Không ồn ào.',
    newsletterPlaceholder: 'Địa chỉ email của bạn',
    newsletterCta: 'Đăng ký',
    newsletterDone: 'Cảm ơn bạn — hẹn gặp trong lá thư tới.',
    rights: 'Bảo lưu mọi quyền.',
    mockNotice: 'Dữ liệu mô phỏng — cấu hình DATABASE_URL để kết nối cơ sở dữ liệu riêng.',
  },
}
